// store/modules/personAssignments.js
import api from "@/config/api";
import { handleApiError } from "@/utils/ErrorHandler";
import { createPaginationModule, defaultPagination } from "@/store/common/pagination";

const assignmentsPag = createPaginationModule('PERSON_ASSIGNMENTS');

const state = () => ({
    allAssignments: [],   // fixed naming consistency
    note: "",
    pagination: defaultPagination(),
    loading: false,
    error: null,
});

const mutations = {
    ...assignmentsPag.mutations,

    SET_ASSIGNMENTS(state, payload) {
        state.allAssignments = payload || [];
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    CLEAR_ASSIGNMENTS(state) {
        state.allAssignments = [];
        state.summary = null;
        state.note = "";
    },
};

const actions = {
    async fetchPersonAssignments({ commit }, { personId, locationId, search = "", page = 1, pageSize = 10 }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const { data } = await api.get(`/manage-user/person-assignments`, {
                params: {
                    personid: personId,
                    locationid: locationId,
                    search,
                    page_size: pageSize,
                    page_number: page
                },
            });

            const pagination = data?.pagination ?? {};

            commit("SET_ASSIGNMENTS", data.data);
            commit(assignmentsPag.SET_PAGINATION, {
                currentPage: pagination.current_page,
                totalPages: pagination.total_pages,
                totalRecords: pagination.total_records,
                pageSize: pagination.page_size,
                hasPrevious: pagination.has_previous,
                hasNext: pagination.has_next,
            });
            return data.data || [];

        } catch (error) {
            const message = handleApiError
                ? handleApiError(error, "Failed to fetch person assignments")
                : error.message || "Failed to fetch person assignments";
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async undeclineWorkgroup({ commit }, { personId, aiwgId, locationId }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const { data } = await api.post(`/manageuserajax`, {
                cmd: "undeclinewg",
                personid: personId,
                aiwgid: aiwgId,
                locationid: locationId,
            });
            return data;
        } catch (error) {
            const message = handleApiError
                ? handleApiError(error, "Failed to undecline workgroup")
                : error.message || "Failed to undecline workgroup";
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    clearAssignments({ commit }) {
        commit("CLEAR_ASSIGNMENTS");
    },
};

const getters = {
    allAssignments: (state) => state.allAssignments,
    assignmentsSummary: (state) => state.summary,
    assignmentsNote: (state) => state.note,
    isAssignmentsLoading: (state) => state.loading,
    getAssignmentsError: (state) => state.error,
    personAssignmentsPagination: (state) => state.pagination,
};

export default {
    state,
    mutations,
    actions,
    getters,
};